<style>
.bg-primary {
  background-color: #1a3665 !important;
}
.bg-active {
  background-color: #3e5d92;
}
.bg-subactive {
  background-color: #486ba7;
}
</style>
<template>
  <CCard>
    <CCardHeader class="bg-primary text-white border-0 font-weight-bold p-3 d-flex align-items-center">{{ this.$string.sidebar.menu_5.sub_menu.menu_10 }}
      <CButton
        color="info"
        style="float:right;margin-right:10px"
        class="btn-md ml-auto"
      >Upload Template</CButton>
      <CButton
        color="success"
        style="float:right;margin-right:10px"
        class="btn-md float-right"
      >Download Template</CButton>
    </CCardHeader>
    <!-- Tabs -->
      <ul class="nav nav-tabs bg-active border-0" id="myTab" role="tablist">
        <li class="nav-item">
          <router-link
            to="/pelatihan/e-sertifikat"
            style="background-color: #486ba7;"            
            class="nav-link p-3 px-5 font-weight-bold text-white border-0"
            id="home-tab"
            data-toggle="tab"
            href="#home"
            role="tab"
            aria-controls="home"
            aria-selected="true"
          >{{ this.$string.sidebar.menu_5.sub_menu.menu_10 }}</router-link>
        </li>
        <li class="nav-item">
          <router-link
            to="/pelatihan/template-e-sertifikat"
            class="nav-link p-3 px-5 font-weight-bold text-white"            
            id="profile-tab"
            data-toggle="tab"
            href="#profile"
            role="tab"
            aria-controls="profile"
            aria-selected="false"
          >{{ this.$string.sidebar.menu_5.sub_menu.menu_13 }}</router-link>
        </li>
      </ul>
    <!-- Data E-Certificate -->
    <CCardBody>
      <CRow>
        <div class="col-sm-12 col-xl-12">
          <div class="form-group">
            <label for="" class="font-weight-bold">Pilih Pelatihan</label>
            <select class="form-control" name id>
              <option>Semua Data</option>
            </select>
          </div>
        </div>
      </CRow>
      <CRow>
        <div class="col-sm-12 col-xl-2">
          <div class="form-group">
            <label for>Data Perhalaman</label>
            <select class="form-control" name id>
              <option>10</option>
              <option>25</option>
              <option>100</option>
              <option>Semua Data</option>
            </select>
          </div>
        </div>
        <div class="col-sm-12 col-xl-3 ml-auto">
          <div class="form-group">
            <label for>Pencarian</label>
            <input type="text" name id class="form-control" placeholder="Cari Data ..." />
          </div>
        </div>
      </CRow>
      <CRow>
        <CCol lg="12" class="table-responsive">
          <CDataTable style="widht:100% !important" :items="items" :fields="fields" hover sorter>
            <template #no="{item}">
              <td class="py-2">{{ item.no }}</td>
            </template>
            <template>
              <td>
                <i class="fa fa-file" aria-hidden="true"></i>
              </td>
            </template>
            <template #_status="{item}">
              <td class="py-2 text-center">
                <!-- <badge class="badge badge-success" v-if="item._status == 1">Terkirim</badge> -->
                <!-- <badge class="badge badge-danger" v-else>Belum Terkirim</badge> -->
                <span class="font-weight-bold text-success" v-if="item._status == 1">Terkirim</span>
                <span class="font-weight-bold text-danger" v-else>Belum Terkirim</span>
              </td>
            </template>
            <template #aksi="{item, index}">
              <td class="py-2 d-flex align-items-center">
                <CButton color="info" class="btn-sm text-white mr-1" square>
                  <font-awesome-icon icon="edit" />
                </CButton>&nbsp;&nbsp;
                <CButton color="danger" class="btn-sm" square @click="deleteData(item, index)">
                  <font-awesome-icon icon="trash" />
                </CButton>
              </td>
            </template>
          </CDataTable>
          <CPagination style="float:right" :active-page.sync="currentPage" :pages="10" responsive />
        </CCol>
      </CRow>
      <!-- Modal Tambah -->
      <CModal
        title="Modal title"
        :show.sync="myModal"
        :no-close-on-backdrop="true"
        :centered="true"        
      >
        <CForm>
          <CRow>
            <div class="modal-body">
              <form>
                <div class="form-row">
                  <div class="form-group col-md-12">
                    <label for="kode_cabang font-weight-bold" class="font-weight-bold">Nama Peserta</label>
                    <select class="form-control" name id>
                      <option>Pilih Nama Peserta</option>
                    </select>
                  </div>
                </div>
                <div class="form-row">
                  <div class="form-group col-md-12">
                    <label for="nama_cabang font-weight-bold" class="font-weight-bold">KAP</label>
                    <input
                      type="text"
                      class="form-control"
                      id="nama_cabang"
                      placeholder="Terisi Berdasarkan Nama Peserta"
                      readonly
                    />
                  </div>
                  <div class="form-group col-md-12">
                    <label
                      for="nama_cabang font-weight-bold"
                      class="font-weight-bold"
                    >Nama Pelatihan</label>
                    <select class="form-control" name id>
                      <option>Pilih Nama Pelatihan</option>
                    </select>
                  </div>
                </div>
                <div class="form-row">
                  <div class="form-group col-md-4">
                    <label
                      for="kode_cabang font-weight-bold"
                      class="font-weight-bold"
                    >Tahun Pelaksanaan</label>
                    <input
                      type="text"
                      class="form-control"
                      id="kode_cabang"
                      placeholder="Terisi Otomatis"
                      readonly
                    />
                  </div>
                  <div class="form-group col-md-4">
                    <label
                      for="kode_cabang font-weight-bold"
                      class="font-weight-bold"
                    >Nama Pelatihan</label>
                    <input
                      type="text"
                      class="form-control"
                      id="kode_cabang"
                      placeholder="Terisi Otomatis"
                      readonly
                    />
                  </div>
                  <div class="form-group col-md-4">
                    <label
                      for="kode_cabang font-weight-bold"
                      class="font-weight-bold"
                    >Katalog Pelatihan</label>
                    <input
                      type="text"
                      class="form-control"
                      id="kode_cabang"
                      placeholder="Terisi Otomatis"
                      readonly
                    />
                  </div>
                </div>
                <div class="form-row ml-1 p-0 mt-2">
                  <label class="font-weight-bold">Perolehan SKP</label>
                </div>
                <div class="form-row">
                  <div class="form-group col-md-4">
                    <label for="kode_cabang font-weight-bold" class="font-weight-bold">Terstruktur</label>
                    <input
                      type="text"
                      class="form-control"
                      id="kode_cabang"
                      placeholder="Terisi Otomatis"
                      readonly
                    />
                  </div>
                  <div class="form-group col-md-4">
                    <label
                      for="kode_cabang font-weight-bold"
                      class="font-weight-bold"
                    >Non Terstruktur</label>
                    <input
                      type="text"
                      class="form-control"
                      id="kode_cabang"
                      placeholder="Terisi Otomatis"
                      readonly
                    />
                  </div>
                  <div class="form-group col-md-4">
                    <label for="kode_cabang font-weight-bold" class="font-weight-bold">Assesment</label>
                    <input
                      type="text"
                      class="form-control"
                      id="kode_cabang"
                      placeholder="Terisi Otomatis"
                      readonly
                    />
                  </div>
                </div>
                <div class="form-row">
                  <div class="form-group col-md-6">
                    <label class="font-weight-bold">Tanda Tangan 1</label>
                    <select name class="form-control" id>
                      <option value>Pilih Signaute 1</option>
                    </select>
                  </div>
                  <div class="form-group col-md-6">
                    <label class="font-weight-bold">Tanda Tangan 2</label>
                    <select name class="form-control" id>
                      <option value>Pilih Signaute 2</option>
                    </select>
                  </div>
                </div>
                <div class="form-row">
                  <div class="form-group col-md-12">
                    <label class="font-weight-bold">Pengiriman ke Email</label>
                    <select name class="form-control" id>
                      <option disabled>Pilih Aksi</option>
                      <option value>Kirim</option>
                      <option value>Tidak Kirim</option>
                    </select>
                  </div>
                </div>
              </form>
            </div>
          </CRow>
        </CForm>
        <template #header>
          <h6 class="modal-title h4 font-weight-bold">Tambah</h6>
        </template>
        <template #footer>
          <CButton @click="myModal = false" color="danger">Tutup</CButton>
          <CButton type="submit" color="success">Simpan</CButton>
        </template>
      </CModal>
      <!-- End Modal -->
    </CCardBody>
    <!-- End Data E-Certificate -->
  </CCard>
</template>
<script>
const items = [
  {
    no: "1",
    no_agt: "51554",
    tahun: "2020",
    nama_peserta: "JOSEPH SISILO",
    kode_ppl: "PPL20027",
    nama_ppl: "PPL KSHUSUS STAF",
    // kap: "DRS. JOSEPH",
    // jam_masuk: "08:00",
    // jam_keluar: "16:00",
    // file: "img.png",
    _status: 1
  },
  {
    no: "2",
    no_agt: "51554",
    tahun: "2020",
    nama_peserta: "JOSEPH SISILO",
    kode_ppl: "PPL20027",
    nama_ppl: "PPL KSHUSUS STAF",
    // kap: "DRS. JOSEPH",
    // jam_masuk: "08:00",
    // jam_keluar: "16:00",
    // file: "img.png",
    _status: 0
  },
  {
    no: "3",
    no_agt: "51554",
    tahun: "2020",
    nama_peserta: "JOSEPH SISILO",
    kode_ppl: "PPL20027",
    nama_ppl: "PPL KSHUSUS STAF",
    // kap: "DRS. JOSEPH",
    // jam_masuk: "08:00",
    // jam_keluar: "16:00",
    // file: "img.png",
    _status: 1
  }
];

const fields = [
  {
    key: "no",
    label: "No",
    sorter: true,
    filter: false,
    _style: "width: 2%"
  },
  {
    key: "no_agt",
    label: "No Peserta",
    sorter: true,
    filter: false
  },
  {
    key: "nama_peserta",
    label: "Nama Peserta",
    sorter: true,
    filter: false
  }, 
  {
    key: "tahun",
    label: "Tahun",
    sorter: true,
    filter: false
  },
  {
    key: "kode_ppl",
    label: "Kode Pelatihan",
    sorter: true,
    filter: false
  },
  {
    key: "nama_ppl",
    label: "Nama Pelatihan",
    sorter: true,
    filter: false
  },  
  {
    key: "_status",
    _style: "text-align: center",
    sorter: false,
    filter: false
  },
  {
    key: "aksi",
    _style: "width: 13% text-align: center",
    sorter: false,
    filter: false
  }
];

export default {  
  data() {
    return {
      items: items.map((item, id) => {
        return { ...item, id };
      }),
      formData: {
        judul: "",
        file: ""
      },
      formData: {
        deskripsi: "",
        file: ""
      },
      fileName: "Choose File...",
      fields,
      currentPage: 3,
      details: [],
      no: 1,
      status: false,
      myModal: false,
      horizontal: { label: "col-3", input: "col-9" },

      collapseDuration: 0,
      content: []
    };
  },
  methods: {
    deleteData() {
      this.$swal
        .fire({
          title: "Peringatan!",
          text: "Apakah anda yakin ingin menghapus data ini?",
          icon: "warning",
          showCancelButton: true,
          confirmButtonText: "Ya",
          cancelButtonText: "Tidak",
          confirmButtonColor: "#d33",
          cancelButtonColor: "#3085d6",
          reverseButtons: true
        })
        .then(result => {
          if (result.value) {
            const Toast = this.$swal.mixin({
              toast: true,
              position: "top-end",
              showConfirmButton: false,
              timer: 3000,
              timerProgressBar: true,
              onOpen: toast => {
                toast.addEventListener("mouseenter", Swal.stopTimer);
                toast.addEventListener("mouseleave", Swal.resumeTimer);
              }
            });
            Toast.fire({
              icon: "success",
              title: "Data Berhasil Dihapus"
            });
          } else if (result.dismiss === Swal.DismissReason.cancel) {
            this.$swal.fire(
              "Cancelled",
              "Your imaginary file is safe :)",
              "error"
            );
          }
        });
    }
  }
};
</script>